import { render } from "./BankBook.vue?vue&type=template&id=17fddda0&scoped=true"
import script from "./BankBook.vue?vue&type=script&lang=js"
export * from "./BankBook.vue?vue&type=script&lang=js"

import "./BankBook.vue?vue&type=style&index=0&id=17fddda0&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17fddda0"]])

export default __exports__